export function SiteRefColumn({ columns }) {
  return columns["SITE_REF"];
}
